import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

interface CommonModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  description?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}

export const CommonModal = React.forwardRef<HTMLDivElement, CommonModalProps>(
  ({ open, onOpenChange, title, description, children, footer, className }, ref) => {
    return (
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent
          ref={ref}
          className={cn('bg-background border-none shadow-lg', className)}
        >
          {(title || description) && (
            <DialogHeader>
              {title && (
                <DialogTitle className="text-xl font-bold text-yellow [text-shadow:1px_1.2px_0_#000]">
                  {title}
                </DialogTitle>
              )}
              {description && <DialogDescription>{description}</DialogDescription>}
            </DialogHeader>
          )}
          {children}
          {footer && <DialogFooter>{footer}</DialogFooter>}
        </DialogContent>
      </Dialog>
    );
  }
);

CommonModal.displayName = 'CommonModal';
